import React from 'react';

interface UnavailableProps {
  className?: string;
}

export const Unavailable: React.FC<UnavailableProps> = () => (
  <div
    className={`font-inter flex w-full flex-col gap-2 pb-16 pt-11 text-center leading-[normal]`}
  >
    <div className="pt-8 font-medium">Вход временно недоступен</div>
    <div className="text-text-secondary">
      Платформа на техническом обслуживании
    </div>
  </div>
);
